import { BaseModel } from 'sjs-base-model';

export default class CountPlayersModel extends BaseModel {

    constructor(data) {
        super();
        this.count = 0;
        this.update(data);
    }
}